import { isFinite } from "lodash-es";

export type IUnitizedValues = (number | undefined)[];

export const validateUnitizedRequired = (values: IUnitizedValues) =>
  values.every(value => isFinite(value));
